
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import LinkInput from "@/components/Reusable/CustomInputs/LinkInput/LinkInput.vue";
import { documentStore, singularityStore, uiStore } from "@/store/store";
import lodash from "lodash";
import { LinkInputValue } from "@/types/link";
import { findNode } from "@/lib/tree/tree";
import SingularityPanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";

@Component({
  components: {
    LinkInput,
    SingularityPanelHeader
  }
})
export default class LinkEditor extends Vue {
  get linkEditorPanelState() {
    return singularityStore.linkEditorPanelState;
  }

  get uiStoreActiveElementId() {
    return uiStore.activeElementId;
  }

  @Watch("uiStoreActiveElementId")
  closePanelIfElementIdChanges() {
    if (this.linkEditorPanelState?.elementId !== this.uiStoreActiveElementId) {
      singularityStore.setLinkEditorPanelState(null);
    }
  }

  get linkPropertyPaths() {
    return singularityStore.linkEditorPanelState?.linkPropertyPaths;
  }

  linkInputValue(linkPropertyPath: string) {
    if (!this.linkEditorPanelState) return null;

    const node = findNode(
      documentStore.document.tree,
      this.linkEditorPanelState.elementId
    );

    if (!node) return null;

    const result = lodash.get(node.data.properties, linkPropertyPath);

    if (!result) return null;

    return result;
  }

  updateLinkInputValue(value: LinkInputValue, linkPropertyPath: string) {
    if (!this.linkEditorPanelState?.elementId) return;

    documentStore.unthrottledPropertyChanged({
      elementId: this.linkEditorPanelState.elementId,
      path: linkPropertyPath,
      value: value,
      meta: {
        snapshotLabel: "Link Editor Input Update"
      }
    });
  }

  close() {
    alert("close");
  }

  backToPageStructurePanel() {
    singularityStore.setLinkEditorPanelState(null);
  }
}
